import { get } from "axios"

const getAlmacen = (busqueda, pagina, filtro) => {
    const token = localStorage.getItem('token');
    return (
        get(`${process.env.REACT_APP_URL_API}almacen?bus=${busqueda}&pag=${pagina}`, {
            headers: {
                'Authorization': `Bearer ${token}`  // Incluye el token JWT en el encabezado
            }
        })
            .then(response => {
                const { data } = response
                return data
            })
            .catch(error => {
                return { error: 401, message: 'Sesión expirada. Por favor, inicia sesión nuevamente.' }
            })
    )
}
export default getAlmacen